var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParadaIndevida(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.27,
    height: 20.069,
    viewBox: "0 0 20.27 20.069",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_863",
    "data-name": "Caminho 863",
    d: "M40.485,30.542h-8.4L26.152,36.42v8.313l5.937,5.878h8.4l5.937-5.878V36.42ZM41.9,43.718,39.459,46.13l-3.173-3.141L33.115,46.13l-2.436-2.412,3.173-3.141-3.173-3.141,2.436-2.412,3.172,3.141,3.173-3.141L41.9,37.436l-3.173,3.141Z",
    transform: "translate(-26.152 -30.542)",
    fill: "red"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParadaIndevida);
export default __webpack_public_path__ + "static/media/parada-indevida.7c74c9ae511c2b4aa84954b6e6865399.svg";
export { ForwardRef as ReactComponent };